var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"icon":"el-icon-download","type":"primary","loading":_vm.loading},on:{"click":function($event){return _vm.onClick()}}},[_vm._v("Pobierz listę w CSV")])}
var staticRenderFns = []

export { render, staticRenderFns }